import React from "react";

import { Row, Col , Input, Select, Card} from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/ContactUs/Branches/Branches.css";


const tdCode = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansUltraLight",
  fontSize: ".8em",
  borderRadius: "10px 0 0 10px",
  color: "#ed1e24"
}
const tdCodeTablet = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansUltraLight",
  fontSize: ".775em",
  borderRadius: "10px 0 0 10px",
  color: "#ed1e24"
}
const tdCodeMobile = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSansUltraLight",
  fontSize: ".75em",
  borderRadius: "10px 0 0 10px",
  color: "#ed1e24",
  paddingTop:"10px"
}
const tdAddress = {
  direction: "rtl",
  textAlign: "right",
  padding: "10px",
  fontFamily: "IranSansLight",
  fontSize: ".85em",
  color: "#8d8d8d"
}
const tdAddressTablet = {
  direction: "rtl",
  textAlign: "right",
  padding: "10px",
  fontFamily: "IranSansLight",
  fontSize: ".8em",
  color: "#8d8d8d"
}
const tdAddressMobile = {
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSansLight",
  fontSize: ".725em",
  color: "#8d8d8d",
  paddingTop:"10px"
}
const tdPhone = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansLight",
  fontSize: ".8em",
  color: "#3d5563"
}
const tdPhoneTablet = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSansLight",
  fontSize: ".775em",
  color: "#3d5563"
}
const tdPhoneMobile = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSansLight",
  fontSize: ".725em",
  color: "#3d5563",
  paddingTop:"10px"
}
const tdTown = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSans",
  fontSize: ".8em",
  color: "#8d8d8d"
}
const tdTownTablet = {
  direction: "rtl",
  textAlign: "center",
  padding: "10px",
  fontFamily: "IranSans",
  fontSize: ".775em",
  color: "#8d8d8d"
}
const tdTownMobile = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSans",
  fontSize: ".725em",
  color: "#8d8d8d",
  paddingTop:"10px"
}
const tdOstan = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSansBold",
  fontSize: ".8em",
  borderRadius: "0 10px 10px 0",
  padding: "10px"
}
const tdOstanTablet = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSansBold",
  fontSize: ".775em",
  borderRadius: "0 10px 10px 0",
  padding: "10px"
}
const tdOstanMobile = {
  direction: "rtl",
  textAlign: "center",
  fontFamily: "IranSansBold",
  fontSize: ".65em",
  borderRadius: "0 10px 10px 0",
  paddingTop:"10px",
}

const BranchesTable = props => {
     return props.size === "laptopdesktop" ? (
         <tr style={{ backgroundColor: "#fff", textAlign: "center" }}>
             <td style={tdCode}>
               {props.code}
             </td>
             <td style={tdAddress}>
               {props.address}
             </td>
             <td style={tdPhone}>
               {props.phone}
               <br/>
                        {props.phoneSec}
             </td>
             <td style={tdTown}>
               {props.town}
             </td>
             <td style={tdOstan}>
               <p style={{ color: "#253d4b", marginTop: "10px" }}>
                 {props.ostan}
               </p>
             </td>
            </tr>  
     ) : props.size === "tablet" ? (
      <tr style={{ backgroundColor: "#fff", textAlign: "center"}}>
      <td style={tdCodeTablet}>
        <p>
        {props.code}
        </p>
      </td>
      <td style={tdAddressTablet}>
        {props.address}
      </td>
      <td style={tdPhoneTablet}>
        <p>
            {props.phone}
            <br/>
                        {props.phoneSec}
        </p>
      </td>
      <td style={tdTownTablet}>
        <p style={{marginTop:"-2.5px"}}>
          {props.town}
        </p>
      </td>
      <td style={tdOstanTablet}>
        <p style={{ color: "#253d4b"}}>
          {props.ostan}
        </p>
      </td>
    </tr> 
     ) : (
                <tr style={{ backgroundColor: "#fff", textAlign: "center"}}>
                  <td style={tdCodeMobile}>
                    <p>
                    {props.code}
                    </p>
                  </td>
                  <td style={tdAddressMobile}>
                    {props.address}
                  </td>
                  <td style={tdPhoneMobile}>
                    <p>
                        {props.phone}
                        <br/>
                        {props.phoneSec}
                    </p>
                  </td>
                  <td style={tdTownMobile}>
                    <p style={{marginTop:"-2.5px"}}>
                      {props.town}
                    </p>
                  </td>
                  <td style={tdOstanMobile}>
                    <p style={{ color: "#253d4b"}}>
                      {props.ostan}
                    </p>
                  </td>
                </tr> 
          );
};

export default BranchesTable;
